import axios from 'axios'
import store from './index'
import { clearClientAuth } from './action'
import { getStoredAuthToken } from './authToken'


const createSubscriber = () => {
    const lateststate = store.getState()
    const token = getStoredAuthToken()
    if (lateststate.isLogin === true && token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } else {
        delete axios.defaults.headers.common['Authorization']

        if (lateststate.isLogin === true) {
            const lastPath = window.location.pathname
            clearClientAuth(store.dispatch)

            if (!lastPath.startsWith('/auth/')) {
                sessionStorage.setItem('lastVisitedPath', lastPath)
                window.location.replace('/auth/signin?sessionExpired=true')
            }
        }
    }
};
store.subscribe(createSubscriber)

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status
        const message = String(error?.response?.data?.message || '')
        const requestHadAuth = Boolean(
            error?.config?.headers?.Authorization || error?.config?.headers?.authorization
        )
        const tokenRejected = status === 401 || /jwt (?:malformed|expired)|invalid token/i.test(message)

        if (requestHadAuth && tokenRejected) {
            const lastPath = window.location.pathname
            clearClientAuth(store.dispatch)

            if (!lastPath.startsWith('/auth/')) {
                sessionStorage.setItem('lastVisitedPath', lastPath)
                window.location.replace('/auth/signin?sessionExpired=true')
            }
        }

        return Promise.reject(error)
    }
)
